export default "__VITE_ASSET__CpRGrhJU__"